// Update price difference for each instrument in the GUIInstruments list
export const handlePriceDifferenceUpdate = (setGUIInstruments, instrumentToken, priceDifference) => {
    setGUIInstruments((prevInstruments) =>
        prevInstruments.map(instrument => {
            if (instrument.instrumentToken === instrumentToken) {
                return { ...instrument, priceDifferencePercentage: priceDifference };
            }
            return instrument;
        })
    );
};

// Callback to handle price difference change for an instrument
export const handlePriceDifferenceChange = (onPriceDifferenceUpdate, GUIInstrument) => {
    return (priceDifference) => {
        onPriceDifferenceUpdate(GUIInstrument.instrumentToken, priceDifference);
    };
};